export default "__VITE_ASSET__u0o$dqI7__"